import { render, staticRenderFns } from "./ISAFallSummary.vue?vue&type=template&id=377919f0&scoped=true&"
import script from "./ISAFallSummary.vue?vue&type=script&lang=js&"
export * from "./ISAFallSummary.vue?vue&type=script&lang=js&"
import style0 from "./ISAFallSummary.vue?vue&type=style&index=0&id=377919f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377919f0",
  null
  
)

export default component.exports